/**
 * VUE入口文件
 */
// -----兼容IE------
import 'babel-polyfill'

// ---- VUE ----
import Vue from 'vue'
import App from './App'
import router from './router'
import Resource from 'vue-resource'
import store from './store'

// ---- element-ui & baize ----
import ElementUI from 'element-ui'
import Baize from '@/baize'

// ---- 组件 ----
import Common from '@/common'

// ---- 公共样式 ----
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import 'font-awesome/css/font-awesome.css'

// ---- 自定义样式 ----
import './assets/css/baize.css'
import './assets/css/global_common.css'
import './assets/css/global_default.css'
import './assets/css/global_font.css'
import './assets/css/global_responsive.css'
import './assets/css/global-img-panel.css'
import './assets/css/global-paper.css'

// ---- VUE配置 ----
Vue.config.productionTip = false
Vue.use(Resource)
Vue.use(ElementUI)
Vue.use(Baize)
Vue.use(Common)

// ---- 全局VUE对象 ----
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js